import(/* webpackMode: "eager" */ "/home/irin/Projects/Vieillir/vieillir-front/app/layout.js");
